import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSwap = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M13.5 6a.9.9 0 0 1 1.578-.592l3.6 4.125a.9.9 0 0 1-1.356 1.184L15.3 8.4V18a.9.9 0 0 1-1.8 0zM6.678 13.283a.9.9 0 1 0-1.356 1.183l3.6 4.126A.9.9 0 0 0 10.5 18V6a.9.9 0 0 0-1.8 0v9.6z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSwap)
export default ForwardRef
